<template>
  <PromoPage
    v-if="promo"
    type-page="purchassing"/>
  <MenuComponent
    v-else
    :filtred_count="filtred_count ">
    <template #navbar="{ navbarMini }">
      <PurchNavBar
        ref="navBar"
        :app_count="app_count"
        :applications="applications"
        :filter.sync="filters"
        :loading="loading"
        :mini="navbarMini"
        :types="types"
        @changeFilter="$_scrollTo(null, 0,0), count = 0"/>
    </template>
    <template #filter>
      <PurchToolbar
        ref="purchToolbar"
        :headers.sync="choosedHeaders"
        :loading="loading"
        :table-mode.sync="tableMode"/>
    </template>
    <template #items>
      <EmptyBlock
        v-if="!loading && (!groups || !Object.keys(groups).length || !applications || !applications.length)"
        :text="empty_text"/>
      <template
        v-else-if="Object.keys(groups).length"
        v-for="([name, items], index) in Object.entries(groups)">
        <div
          v-if="items.length"
          :key="name + filtredItems.length + Object.keys(groups).length">
          <div
            class="text-left pt-8 pr-10 pb-2 pb-2 h4-headline main__green"
            :data-qa="`period-name-${index}`"
            style="z-index: 2; position: sticky; top: -24px;">
            {{ $t(name) }}
          </div>
          <div
            v-if="tableMode">
            <PurchTable
              :key="items.length + name"
              :all-headers="headers"
              :applications="items"
              :choosed.sync="choosed"
              :choosed-headers="choosedHeaders"
              :index="index"/>
          </div>
          <div
            v-else
            class="">
            <PurchaseCard
              v-for="(application, n) in items"
              :key="`${application.id}_${n}`"
              ref="purch_card"
              :application="application"
              :filter_type="filters.from_bar"
              :last="n == (items.length - 1)"
              :loading="loading"
              @deleteFromTemplate="deleteFromTemplate"
              @removeApp="removeDraft"
              @saveAsTemplate="saveAsTemplate"/>
          </div>
        </div>
      </template>
    </template>
    <template #loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="can_load"
        class="mt-3"
        :loading="loading "
        :pixels_when_update=" tableMode ? 70 : 150"/>
    </template>
  </MenuComponent>
</template>

<script>
import PromoPage from 'components/errors/PromoPage.vue'
import PurchTable from 'components/purchasing/PurchTable.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import PurchNavBar from 'components/purchasing/PurchNavBar.vue'
import PurchToolbar from 'components/purchasing/PurchToolbar.vue'
import PurchaseCard from 'components/purchasing/PurchaseCard.vue'
import EmptyBlock from 'components/common/elements/EmptyBlock.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'

import { doomMixin, snackbarMixin, filterSortMixin, applicationMixin, datePickerMixin, storageMixin, modalMixin, filtersTemplatesMixin } from 'mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'purchasing',
  mixins: [ doomMixin, snackbarMixin, filterSortMixin, applicationMixin, datePickerMixin, storageMixin, modalMixin, filtersTemplatesMixin],
  data() {
    return {
      promo: false,
      tableMode: false,
      count: 0,
      choosed: [],
      groups: {},
      filtredItems: [],
      filtred_count: 0,
      filters: {
        from_menu: [],
        from_bar: '',
        search: ''
      },
      loading: false,
      applications: [],
      app_count: {},
      choosedHeaders: [],
      startProp: {
        countLoadItem: null,
        scrollTopId: null,
      },
      users: []
    }
  },
  async mounted() {
    this.$root.$on('loadData', this.loadPurch)
    this.checkPromo()
    this.startProp = {}
    if (this.$route.meta.from.name) {
      this.startProp.countLoadItem = this.$_getPropFromLocalStorage('purchasings.countLoadItem', 0),
      this.startProp.scrollTopId = this.$_getPropFromLocalStorage('purchasings.scrollTopId', null)
    }
    this.loading = true
    this.tableMode = this.$_getPropFromLocalStorage('purchasings.tableMode', false)
    this.choosedHeaders = this.headers.slice(0)
  },
  beforeDestroy() {
    this.$root.$off('loadData', this.loadPurch)
  },
  computed: {
    ...mapGetters({
      currentOrganization: 'getCurrentOrganization',
      settings: 'getSettings',
      changeOrganisation: 'changeOrganisation',
    }),
    stored_filters() {
      return this.$store.getters.getFilters?.ORDERS || {}
    },
    empty_text() { // todo none apps
      return this.filters.from_menu.length ? this.$t('Tenders.NoResultsForSearch') : this.$t(this.types.find(type => type.type == this.filters.from_bar)?.none || 'Purchasing.NoApplications')
    },
    headers() {
      return [
        {text: '', value: 'data-table-select', width: '1%' },
        {text: this.$t('Purchasing.Number'), value: 'number', sortable: false, width: '5%', disableFilter: true},
        {text: this.$t('Menu.Purchasing'), value: 'title', sortable: false, width: '20%', disableFilter: true},
        {text: this.$t('Purchasing.Status'), value: 'status', sortable: false, width: '15%'},
        {text: this.$t('Purchasing.Created'), value: 'responsible.fullName', sortable: false, width: '15%'},
        {text: this.$t('Purchasing.DeliveryDate'), value: 'approvedSupplyDate', sortable: false,  width: '15%'},
        {text: this.$t('Tenders.DateOfCreation'), value: 'creationDate', sortable: false,  width: '15%'},
        {text: this.$t('Purchasing.Sum'), value: 'summa', sortable: false, width: '13%'},
        {text: '', value: '', sortable: false, width: ''},
        {text: '', value: 'comments', sortable: false, width: '1%'},
      ]
    },
    routeParamCode: {
      get: function() {
        return this.$route.params
      }
    },
    per_page() {
      if (this.startProp?.countLoadItem) {
        return this.startProp.countLoadItem
      }
      let elm = this.$el
      return Math.floor((elm?.clientHeight || 0) / (this.tableMode ? 60 : 150))
    },
    departments() {
      return [
        {name: 'Purchasing.TechnologyDepartment', amount: this.applications.length},
        {name: 'Purchasing.DesignDepartment', amount: this.applications.length}
      ]
    },
    can_load() {
      let
        filter_type = this.filters.from_bar,
        count = this.app_count[ filter_type ]?.count
      return !this.loading &&  this.count == this.applications.length
        && count != this.applications.length
    },
    types() {
      return [
        {
          name: 'Purchasing.AllPurchases',
          type: 'ALL' ,
          icon: 'table',
          none: 'Purchasing.NoApplications',
          all: true,
        },
        { name: 'Purchasing.Urgent',
          type: 'URGENT',
          class: 'pl-7',
        },
        { name: 'Purchasing.WaitConfirmation',
          // filter: this.waiting,
          type: 'WAITING_ME',
          class: 'pl-7',
        },
        {
          name: 'Purchasing.Mine',
          type: 'CREATED_BY_ME',
          class: 'pl-7',
        },
        {
          name: 'Purchasing.Templates',
          type: 'TEMPLATE' ,
          icon: 'draft',
          none: 'Purchasing.NoTemplates',
        },
        {
          name: 'Purchasing.Drafts',
          type: 'DRAFT' ,
          icon: 'edit',
          none: 'Purchasing.NoDrafts',
        },
      ]
    },
  },
  methods: {
    loadPurch(update) {
      this.filters.from_menu.filters =  update.filters ?? this.filters.from_menu.filters
      this.filters.from_menu.mode = update.filters_mode ?? this.filters.from_menu.mode
      this.filters.from_bar = update.bar ?? (this.filters.from_bar || 'ALL')
      this.filters.search = update.search ?? (this.filters.search || '')

      if (this.$refs.purchToolbar.$refs.filters) {
        this.$refs.purchToolbar.$refs.filters.searchValue = this.filters.search
      }

      if (update.filters) {
        this.filterApps('MENU', true)
      } else if ( Object.keys(update).includes('search')) {
        this.filterApps('SEARCH',  true)
      } else if (update.bar) {
        this.filterApps('BAR')
      }
    },
    setOldScrollPosition() {
      if (!this.$route.meta.from.name || !this.startProp) { return }

      if (this.startProp.countLoadItem) {
        this.startProp.countLoadItem = 0
      }
      if (this.startProp?.scrollTopId) {
        setTimeout(() => {
          if (document.getElementById(this.startProp?.scrollTopId)) {
            document.getElementById(this.startProp?.scrollTopId).scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            })
            this.startProp = null
            this.$_savePropToLocalStorage('purchasings.scrollTopId', null)
          }
        }, 500)
      }

      this.$_savePropToLocalStorage('purchasings.countLoadItem', null)
    },
    async infinityLoad() {
      if (!this.loading) {
        await this.filterApps()
      }
    },
    getBudjet(items) {
      return items.reduce((total, item) => total + item.summa, 0)
    },
    deleteFromApps(item) {
      let filter = (el) => {
        if (Array.isArray(item)) {
          return !this.$_.find(item, it => it.id == el.id)
        } else {
          return el.id != item?.id
        }
      }
      this.applications = this.$_.filter(this.applications, filter)
      Object.entries(this.groups).forEach(([key, items]) => {
        this.groups[key] =  this.$_.filter(items,  filter)
      })
    },
    async removeDraft(item) {
      this.deleteFromApps(item)
      await this.updateCount()
      await this.filterApps(null, true)
      if (this.choosed.length) {
        this.choosed = []
      }
    },
    async saveAsTemplate() {
      await this.updateCount()
      if (this.filters?.from_bar?.type == 'TEMPLATE') {
        await this.filterApps(null,  true)
      }
    },
    async deleteFromTemplate(item) {
      await this.updateCount()
      if (this.filters?.from_bar?.type == 'TEMPLATE' && this.count > this.app_count?.TEMPLATE?.count) {
        this.deleteFromApps(item)
        await this.filterApps(null, true)
      }
    },
    async checkPromo() {
      return new Promise(async (resolve) => {
        const promo = this.$router.app.$acl.not.check('onlyApps')
        if (!promo) {
          await this.$_getFiltersFromDBStorage()
            .then(async (storage_filters) => {

              this.$store.dispatch('getStatuses')
              this.users = await this.$store.dispatch('getCreateOrdersUsers', true)

              let type = ''
              let checkActualFilters = (filters) => {
                if (filters?.some(filt => filt.id == 'applicants')) {
                  let filtred = filters?.filter((filt) => {
                    let creator = filt.id == 'applicants'
                    if (creator) {
                      filt.search = filt.search.filter(el => this.users.some(it => (el?.id || el) == (it?.id || it)))
                      creator = creator && !filt.search.length
                    }
                    return !creator
                  })
                  if (filtred?.length != filters?.length) {
                    return filtred
                  }  // якщо змінилась кількість фільтрів після відбору існуючих або кількість об'єктів в пошуку то обновляємо сторедж і самі фільтри
                }
                return filters
              }

              if (this.$route?.query?.type == 'drafts') {
                type =  'DRAFT'
                this.$router.replace('')
              } else {
                type = storage_filters.type
              }
              await this.updateFiltersFromStore(checkActualFilters, type || 'ALL')
            })
        }
        this.promo = promo
        resolve(promo)
      })
    }
  },
  watch: {
    async changeOrganisation(val) {
      if (!val) {
        this.loading = true
        this.users = await this.$store.dispatch('getCreateOrdersUsers', true)
        this.checkPromo()
        // this.loadData()
      } else {
        this.count = 0
        this.applications = []
        this.groups = {}
      }
    },
    tableMode(val) {
      this.$_closeSnackbar()
      this.choosed = []
      if (val) {
        this.infinityLoad()
      }
      this.$_savePropToLocalStorage('purchasings.tableMode', val)
    },
    choosed(val) {
      if (val.length > 0) {
        this.$_openSnackbar({
          name: 'applications',
          elements: val,
          deleteFromTemplate: this.deleteFromTemplate,
          saveAsTemplate: this.saveAsTemplate,
          removeDraft: this.removeDraft,
          rejectChoosed: () => { this.choosed = [] }
        })
      } else if (val.length == 0) {
        this.$_closeSnackbar()
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.params && to.params.id) {
      this.$_savePropToLocalStorage('purchasings.scrollTopId', to.params.id)
    }
    this.$_savePropToLocalStorage('purchasings.countLoadItem', this.applications?.length)
    next()
  },
  components: {
    PromoPage,
    EmptyBlock,
    PurchTable,
    PurchNavBar,
    PurchaseCard,
    PurchToolbar,
    MenuComponent,
    InfinityUpdater,
  }
}
</script>
<style lang="scss" scoped>
.sticky {
  z-index: 6;
  position: sticky;
  top: 64px !important;
}

.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
opacity: 0;
}

.purch-view-enter-active, .purch-view-leave-active {
  transition: opacity .2s ease;
}
.purch-view-enter, .purch-view-leave-to
 {
  opacity: 0;
}
</style>
